// @flow

import isNotEmpty from './isNotEmpty';
import each from './each';

export default function filter<T>(array: T[], cond?: (T) => boolean = isNotEmpty): T[] {
   const res = [];

   each(array, o => {
      if (cond(o)) {
         res.push(o);
      }
   });

   return res;
}
